import { TuiDay } from '@taiga-ui/cdk';
import { Maybe } from '@iss/libs/graphql';
import { AbstractControl, NG_VALIDATORS, ValidationErrors, Validator } from '@angular/forms';
import { Directive, inject, Input } from '@angular/core';
import { DatePipe } from '@angular/common';

import { DateFormValidators } from '../validators';

const selector =
  '' +
  'tui-input-date[max][formControlName],' +
  'tui-input-date[max][formControl],' +
  'tui-input-date[max][ngModel],' +
  'tui-input-date[maxDate][formControlName],' +
  'tui-input-date[maxDate][formControl],' +
  'tui-input-date[maxDate][ngModel]'
;

@Directive({
  selector,
  providers: [
    {
      provide: NG_VALIDATORS,
      useExisting: MaxDateDirective,
      multi: true,
    },
    DatePipe,
  ],
  standalone: true,
})
export class MaxDateDirective implements Validator {
  private readonly date = inject(DatePipe);

  @Input('max')
  public max: Maybe<TuiDay>;

  @Input('maxDate')
  public maxDate: Maybe<TuiDay>;

  public validate(control: AbstractControl): ValidationErrors | null {
    const maxDate = this.max || this.maxDate;
    const max = this.date.transform(maxDate?.toLocalNativeDate(), 'yyyy-MM-dd');
    if (!max) return null;

    return DateFormValidators.maxDate(max)(control);
  }
}
